import { routes } from '@/infrastructure/const/routes';
import { replaceWords } from '@/utils/helpers/replace-words';

export const getReciterSurahPath = (
  reciterSlug: string,
  surahSlug: string
): string =>
  replaceWords(routes.reciterSurah, { reciterSlug, surahSlug });
